import React from 'react';
import { Button, Form, Divider, Col, Row, Alert, Spin } from 'antd';
import dayjs from 'dayjs';

import Tags from './components/Tags';
import City from './components/City';
import River from './components/River';
import Voivodeship from './components/Voivodeship';
import Level from './components/Level';
import TrailDistance from './components/TrailDistance';
import TripTime from './components/TripTime';
import Description from './components/Description';
import CustomerMessage from './components/CustomerMessage';
import StartCooridinates from './components/StartCoordinates';
import EndCoordinates from './components/EndCoordinates';
import Visible from './components/Visible';
import StartTime from './components/StartTime';
import EndTime from './components/EndTime';
import Active from './components/Active';
import Title from './components/Title';
import Url from './components/Url';
import TripInterval from './components/TripInterval';

import { trailTimeFormat } from '../../../../consts/dates';

const TrailForm = (props) => {
    const { form, successHandler, submitButtonText, loading, mode } = props;

    const isNewTrail = mode === 'new';

    const onFinish = (values) => {
        const startCoordinates =
            values.startCoordinatesLat && values.startCoordinatesLng
                ? `${values.startCoordinatesLat}/${values.startCoordinatesLng}`.replaceAll(
                      ',',
                      '.',
                  )
                : '';
        const endCoordinates =
            values.endCoordinatesLat && values.endCoordinatesLng
                ? `${values.endCoordinatesLat}/${values.endCoordinatesLng}`.replaceAll(
                      ',',
                      '.',
                  )
                : '';

        const excludedCoords = [
            'startCoordinatesLat',
            'startCoordinatesLng',
            'endCoordinatesLat',
            'endCoordinatesLng',
        ];

        //throw out excludedCoords - more detailed
        const filteredValues = Object.keys(values).reduce((acc, key) => {
            if (!excludedCoords.includes(key)) {
                acc[key] = values[key];
            }
            return acc;
        }, {});

        const formValues = {
            ...filteredValues,
            startTime: values.startTime.format(trailTimeFormat),
            endTime: values.endTime.format(trailTimeFormat),
            startCoordinates,
            endCoordinates,
            tripTimeMinutes: Number(values.tripTimeMinutes) || undefined,
            tripIntervalMinutes:
                Number(values.tripIntervalMinutes) || undefined,
            title: values.title.trim(),
            distanceMeters: Number(values.distanceMeters) || undefined,
            tags: values.tags?.join(',') || '',
            difficultyLevel: values.difficultyLevel,
            active: !!values.active,
            visible: !!values.visible,
        };

        successHandler(formValues);
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const initialValues = {
        difficultyLevel: 1,
        remember: true,
        visible: false,
        active: false,
        startTime: dayjs('08:00', trailTimeFormat),
        endTime: dayjs('18:00', trailTimeFormat),
    };

    return (
        <Spin spinning={loading}>
            <Form
                form={form}
                initialValues={initialValues}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <Row justify="space-around" gutter={[30, 20]}>
                    <Col span={24} md={12}>
                        <Title />
                        <Url />
                        <River />
                        <TrailDistance />
                        <TripTime />
                        <Description />
                    </Col>

                    <Col span={24} md={12}>
                        <City />
                        <Voivodeship />
                        <Level />

                        <Tags />
                    </Col>
                </Row>

                <Visible />

                <Divider orientation="left" style={{ marginTop: 30 }}>
                    Trasa na mapie:
                </Divider>

                <StartCooridinates />
                <EndCoordinates />

                <Divider orientation="left" style={{ marginTop: 30 }}>
                    Dane na potrzeby rezerwacji online:
                </Divider>

                <CustomerMessage />
                <StartTime />
                <EndTime />
                <TripInterval />

                <Active disabled={isNewTrail} />

                {/* {isNewTrail && (
                    <Alert
                        type="warning"
                        message="Aby włączyć rezerwacje online należy utworzyć trasę a następnie skonfigurować sprzęt i ceny."
                        style={{ marginBottom: 20 }}
                    />
                )} */}

                <Form.Item shouldUpdate wrapperCol={{ offset: 0, span: 24 }}>
                    {() => (
                        <>
                            {form
                                .getFieldsError()
                                .some((item) => item.errors.length > 0) && (
                                <Alert
                                    type="error"
                                    message="Popraw błędy w formularzu"
                                    style={{ marignBottom: 20 }}
                                />
                            )}
                        </>
                    )}
                </Form.Item>

                <div style={{ textAlign: 'right' }}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                        size="large"
                    >
                        {submitButtonText}
                    </Button>
                </div>
            </Form>
        </Spin>
    );
};
export default TrailForm;
